// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItem-cls1___317a5f1290dea8c212b{/*!*/}.CreateSocialItem-cls2___180ee9af174485067ea{display:flex;flex-direction:column;grid-gap:8px;gap:8px;flex-grow:1;overflow-y:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItem-cls1___317a5f1290dea8c212b",
	"cls2": "CreateSocialItem-cls2___180ee9af174485067ea CreateSocialItem-cls1___317a5f1290dea8c212b"
};
export default ___CSS_LOADER_EXPORT___;
